/**
 * Import the React library and the Loader image from the specified path.
 * @module
 * @requires React
 * @requires ../../assets/images/giphy.gif
 */
import React from "react";
import Loader from '../../assets/images/giphy.gif';
/**
 * A custom button component that renders a button element with customizable properties.
 * @param {Object} props - The properties for the button component.
 * @param {string} title - The title of the button.
 * @param {ReactNode} children - The child elements of the button.
 * @param {boolean} disabled - Whether the button is disabled or not.
 * @param {string} type - The type of the button.
 * @param {boolean} loading - Whether the button is in a loading state or not.
 * @param {string} className - The CSS class name for the button.
 * @param {ReactNode} icon - The icon element to display within the button.
 */
const CustomButton = (props) => {
  const {
    title,
    children,
    disabled,
    type,
    loading = false,
    className = "",
    icon,
    id,
    onKeyDown,
    onClick,
  } = props;
  return (
    <button
      id={id}
      className={
        disabled
          ? "custombtn Button-disable btn btn-primary "
          : className + loading
            ? "custombtn btn-loading btn btn-primary btn-block " + className
            : "custombtn " + className
      }
      type={type}
      onKeyDown={onKeyDown}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? <div className='btn-loader'><img src={Loader} alt='loader' height={20} width={20} /></div>
        : title
      }
      <>
        {icon}

      </>
      {children}
    </button>
  );
};

export default CustomButton;
